/* Tokens.js */

"use strict";

const tokens = [
    "namedgroup_yellow",
    "namedgroup_purple",
    "namedgroup_blue",
    "namedgroup_saddlebrown",
    "namedgroup_blueviolet",
    "namedgroup_khaki",
    "namedgroup_cornflowerblue",
    "namedgroup_darkgreen",
    "namedgroup_darkorange",
    "namedgroup_inkblue",
    "namedgroup_darkolivegreen",
    "namedgroup_pink",
    "namedgroup_gold",
    "namedgroup_greenyellow",
    "namedgroup_hotpink",
    "namedgroup_lightpink",
    "namedgroup_mediumpurple",
    "namedgroup_orange",
    "namedgroup_gray",
    "namedgroup_wheat",
];

module.exports = tokens;
